import {
  useMutation,
  type DefaultError,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";

type AppMutationOptions<TData, TError, TVariables, TContext> =
  UseMutationOptions<TData, TError, TVariables, TContext> & {
    /**
     * Who shows the error toast.
     * - "global": the MutationCache shows it; the mutation and its callers do not.
     * - "local": the mutation or its caller shows its own toast; the global one is suppressed.
     */
    errorToast: "global" | "local";
  };

export function useAppMutation<
  TData = unknown,
  TError = DefaultError,
  TVariables = void,
  TContext = unknown,
>({
  errorToast,
  meta,
  ...options
}: AppMutationOptions<TData, TError, TVariables, TContext>): UseMutationResult<
  TData,
  TError,
  TVariables,
  TContext
> {
  return useMutation({
    ...options,
    meta:
      errorToast === "local" ? { ...meta, suppressGlobalError: true } : meta,
  });
}
